import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Modal, Radio } from '@mui/material';

// ============================================
// Modal Container & Layout
// ============================================
export const StyledModal = styled(Modal)({});

export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '848px',
  maxWidth: '90vw',
  maxHeight: '90vh',
  backgroundColor: '#fff',
  boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.15)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 32px',
  height: '56px',
  backgroundColor: '#262626',
  flexShrink: 0,
});

export const ModalHeaderTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  color: 'white',
});

export const CloseIconWrapper = styled(Box)({
  width: '32px',
  height: '32px',
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    opacity: 0.7,
  },
});

export const ModalContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  padding: '32px',
  maxHeight: '60vh',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '3px',
  },
});

// ============================================
// Section (Locker Area Group)
// ============================================
export const SectionWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const SectionHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const SectionTitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const SectionTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
  letterSpacing: '-0.16px',
});

export const SectionCount = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#0F7F85',
  letterSpacing: '-0.16px',
});

export const SectionDivider = styled(Box)({
  height: '2px',
  width: '100%',
  borderBottom: '1px solid #d9d9d9',
  opacity: 0.25,
});

// ============================================
// Locker Cards Grid
// ============================================
export const LockerCardsWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '32px',
});

export const LockerCardRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const StyledRadio = styled(Radio)({
  padding: 0,
  width: '24px',
  height: '24px',
  '& .MuiSvgIcon-root': {
    fontSize: '24px',
  },
  '&.Mui-checked': {
    color: '#58B9C1',
  },
  '&:not(.Mui-checked)': {
    color: '#d9d9d9',
  },
});

export const LockerCard = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected',
})(({ isSelected }) => ({
  flex: 1,
  padding: '16px',
  borderRadius: '12px',
  border: isSelected ? '1px solid #58B9C1' : '1px solid #d9d9d9',
  backgroundColor: isSelected ? '#F3F9FA' : '#FAFBFC',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: '#58B9C1',
  },
}));

export const CardContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const CardTopRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const CardTopLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const LockerNumber = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#0F7F85',
  letterSpacing: '-0.14px',
});

export const BranchName = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
  letterSpacing: '-0.14px',
});

export const LockerBadge = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#0F7F85',
  letterSpacing: '-0.14px',
});

export const ProductName = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
  letterSpacing: '-0.16px',
});

export const CardBottomRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const ValidityWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const ValidityLabel = styled(Typography)({
  fontSize: '12px',
  fontWeight: 500,
  color: '#737373',
  letterSpacing: '-0.12px',
});

export const ValidityDate = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
  letterSpacing: '-0.14px',
});

export const RemainingDays = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isExpiringSoon',
})(({ isExpiringSoon }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: isExpiringSoon ? '#EE735A' : '#0F7F85',
  letterSpacing: '-0.14px',
}));

// ============================================
// Footer & Buttons
// ============================================
export const ModalFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  padding: '0 32px 32px 32px',
});

export const CancelButton = styled(Button)({
  width: '120px',
  height: '48px',
  backgroundColor: '#D9D9D9',
  color: '#404040',
  borderRadius: '8px',
  fontSize: '20px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#c9c9c9',
  },
});

export const ConfirmButton = styled(Button)(({ disabled }) => ({
  width: '240px',
  height: '48px',
  backgroundColor: disabled ? '#ccc' : '#0F7F85',
  color: 'white',
  borderRadius: '8px',
  fontSize: '20px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: disabled ? '#ccc' : '#0d6d72',
  },
  '&.Mui-disabled': {
    color: 'white',
    backgroundColor: '#ccc',
  },
}));
